//global stores
import { utilityMutations } from '@v/Core/Global/Store/utility';
import { formProcessingActions, formProcessingGetters, formProcessingMutations, formProcessingState } from '@v/Core/Global/Store/form-processing';

export const state = {
    ...formProcessingState,
    errorMessage: null,
    recaptchaType: null,
    isCaptchaValid: false,
    showSuccessMessage: false,
    executeInvisibleHcaptcha: false,
    formId: '#site-testimonial-form',
}

export const getters = {
    ...formProcessingGetters
}

export const mutations = {
    ...utilityMutations,
    ...formProcessingMutations,
}

export const actions = {
    ...formProcessingActions,
    set({ commit }, payload){
        commit('SET', payload);
    },
    captchaVerified({ commit, state, dispatch }) {
        commit('SET', ['isCaptchaValid', true]);

        if(state.recaptchaType == 'invisible'){
            dispatch('submitForm');
        }
    },
    captchaExpired({ commit }) {
        commit('SET', ['isCaptchaValid', false]);
        commit('SET', ['executeInvisibleHcaptcha', false]);
        commit('SET', ['showSuccessMessage', false]);
        commit('SET', ['errorMessage', 'Captcha has expired please do the challenge again.']);
    },
    resetFormValidation({ commit, getters }){
        commit('SET', ['isValid', null]);
        commit('SET', ['errorMessage', null]);
        commit('SET', ['isFormProcessing', false]);

        let formId = getters.getFormId;
        let form   = document.querySelector(formId);
        if(form.classList.contains('was-validated')){
            form.classList.remove('was-validated');
        }

        //go through each input and remove error class and error messages
        let inputs = document.querySelectorAll('.is-invalid');
        inputs.forEach(input => {
            if(input.classList.contains('is-invalid')){
                input.classList.remove('is-invalid');
            }
            //resets the invalid feedback div to default
            input.nextElementSibling.innerHTML = input.dataset.invalidFeedback;
        });
    },
    submitForm({ state, commit, dispatch, getters}){
        let formId   = getters.getFormId;
        let form     = document.querySelector(formId);
        let formData = new FormData(form);

        //if recaptcha is invisible set execute to true
        if (!state.isCaptchaValid && state.recaptchaType == 'invisible') {
            commit('SET', ['executeInvisibleHcaptcha', true]);
        }

        if(state.isCaptchaValid){
            dispatch('validateForm', formId);

            if(getters.getFormIsValid){
                //set the form processing variable
                dispatch('setFormProcessing', true);

                return axios.post('/testimonials/form', formData)
                .then(response => {
                    //If successful
                    if (response.status == 201 || response.status == 200) {
                        //Show success notification
                        commit('SET', ['showSuccessMessage', true]);

                        //reset all form processing variables
                        dispatch('resetFormValidation');
                    }
                }).catch(error => {
                    //set the form processing variable
                    dispatch('setFormProcessing', false);

                    if (error.request) {
                        if (error.request.status == 422) {
                            const data   = JSON.parse(error.request.responseText);
                            const errors = typeof data[0] === "object" ? data[0] : JSON.parse(data[0]);
                            const errorMessage = data.message;
                            let formErrors  = '';

                            formErrors += `<p>${errorMessage}<p>`;

                            let errorsUl = document.createElement('ul');
                            errorsUl.classList.add('list-unstyled');

                            for (error in errors) {
                                errorsUl.innerHTML += `<li>${errors[error]}</li>`;
                                let input = form.querySelector(`[name="${error}"]`);

                                if(input){
                                    input.classList.add('is-invalid');
                                    if(input.nextElementSibling){
                                        input.nextElementSibling.innerHTML = errors[error];
                                    }
                                }
                            }

                            formErrors += errorsUl.innerHTML;

                            commit('SET', ['errorMessage', formErrors]);
                        } else {
                            commit('SET', ['errorMessage', 'An unexpected error occured. Please try again later.']);
                            logApplicationError(error);
                            console.log(error);
                        }
                    } else {
                        commit('SET', ['errorMessage', 'An unexpected error occured. Please try again later.']);
                        logApplicationError(error);
                        console.log(error);
                    }
                });
            }
        } else {
            if (state.recaptchaType != 'invisible') {
                commit('SET', ['errorMessage', 'Please check the recaptcha box.']);
            }
        }
    }
}

export default { namespaced: true, state, getters, mutations, actions };